// extracted by mini-css-extract-plugin
export default {"container":"admin_container__t7MTG","container_title":"admin_container_title__Q8Bfb","container_title__email":"admin_container_title__email__li-g+"};